import { c as _c } from "react/compiler-runtime";
// A person's initials in a circle (nav people, session row, Settings). `on` = selected. Styles: book.css `.initials`.
import { initials } from "@/lib/filter";
export function Initials(t0) {
  const $ = _c(5);
  const {
    name,
    on
  } = t0;
  const t1 = on ? "initials on" : "initials";
  let t2;
  if ($[0] !== name) {
    t2 = initials(name);
    $[0] = name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <span className={t1} aria-hidden={true}>{t2}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}